import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import SignUpIntro from '../components/signup/SignUpIntro';
import { useLanguage } from '../contexts/LanguageContext';
import config from '../config/env.config';
import '../styles/SignUp.css';

const SignUp = () => {
  const { language } = useLanguage();

  const metaContent = {
    en: {
      title: 'Sign Up - Team Agua Rotterdam',
      description: 'Join Team Agua Rotterdam for Brazilian Jiu-Jitsu classes in Rotterdam. Start your registration through our membership partner.',
      buttonText: 'Start registration',
      cancelTitle: 'Cancel membership',
      cancelText: 'To cancel your membership, please send us a message through the contact form.',
      cancelLink: 'Go to contact form',
    },
    nl: {
      title: 'Inschrijven - Team Agua Rotterdam',
      description: 'Schrijf je in voor Brazilian Jiu-Jitsu lessen bij Team Agua Rotterdam. Start je inschrijving via onze lidmaatschapspartner.',
      buttonText: 'Start registratie',
      cancelTitle: 'Uitschrijven',
      cancelText: 'Wil je je lidmaatschap opzeggen? Stuur ons dan een bericht via het contactformulier.',
      cancelLink: 'Ga naar het contactformulier',
    },
  };

  const content = metaContent[language] || metaContent.en;

  return (
    <div className="signup-page">
      <Helmet>
        <title>{content.title}</title>
        <meta name="description" content={content.description} />
        <link rel="canonical" href="https://rotterdam.aguabjj.nl/signup" />
        
        {/* Open Graph */}
        <meta property="og:title" content={content.title} />
        <meta property="og:description" content={content.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://rotterdam.aguabjj.nl/signup" />
        <meta property="og:image" content="https://rotterdam.aguabjj.nl/images/team-agua-500.png" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={content.title} />
        <meta name="twitter:description" content={content.description} />
        <meta name="twitter:image" content="https://rotterdam.aguabjj.nl/images/team-agua-500.png" />
      </Helmet>

      <div className="container">
        <SignUpIntro />
        <div className="signup-cta">
          <a
            href={config.externalUrls.signupUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary agua-crooked-frame signup-button"
          >
            {content.buttonText}
          </a>
        </div>

        <section className="cancel-membership-section">
          <h2 className="cancel-membership-title">{content.cancelTitle}</h2>
          <p className="cancel-membership-text">{content.cancelText}</p>
          <Link to="/#contact" className="cancel-membership-link">
            {content.cancelLink}
          </Link>
        </section>
      </div>
    </div>
  );
};

export default SignUp;
